import { Record as record } from 'immutable'
import { history } from '../store'
import { obj, HTTP } from './utils'

// constants
const key = 'notes'
export const consts = {
  GET_LIST_REQUEST: `${key}/GET_LIST_REQUEST`,
  GET_LIST_SUCCESS: `${key}/GET_LIST_SUCCESS`,
  GET_LIST_FAIL: `${key}/GET_LIST_FAIL`,

  GET_ITEM_REQUEST: `${key}/GET_ITEM_REQUEST`,
  GET_ITEM_SUCCESS: `${key}/GET_ITEM_SUCCESS`,
  GET_ITEM_FAIL: `${key}/GET_ITEM_FAIL`,

  ADD_ITEM_REQUEST: `${key}/ADD_ITEM_REQUEST`,
  ADD_ITEM_SUCCESS: `${key}/ADD_ITEM_SUCCESS`,
  ADD_ITEM_FAIL: `${key}/ADD_ITEM_FAIL`,

  REMOVE_ITEM_REQUEST: `${key}/REMOVE_ITEM_REQUEST`,
  REMOVE_ITEM_SUCCESS: `${key}/REMOVE_ITEM_SUCCESS`,
  REMOVE_ITEM_FAIL: `${key}/REMOVE_ITEM_FAIL`,

  REPLACE_ITEM_REQUEST: `${key}/REPLACE_ITEM_REQUEST`,
  REPLACE_ITEM_SUCCESS: `${key}/REPLACE_ITEM_SUCCESS`,
  REPLACE_ITEM_FAIL: `${key}/REPLACE_ITEM_FAIL`,

  SET_ITEM_STATE: `${key}/SET_ITEM_STATE`,
}


// initial state
const Item = record({
  date: new Date(),
  clientId: '',
  clientFullName: '',
  noteTitle: '',
  description: '',
  noteType: 0,
})

const InitialState = record({
  isFetching: false,
  list: [],
  item: new Item(),
  error: null,
})


// actions
export const getList = () => (dispatch) => {
  dispatch({ type: consts.GET_LIST_REQUEST })
  return HTTP.get(`/${key}${history.location.search}`)
    .then(response => dispatch({ type: consts.GET_LIST_SUCCESS, response }))
    .catch(error => dispatch({ type: consts.GET_LIST_FAIL, error }))
}

export const getItem = (id) => (dispatch) => {
  dispatch({ type: consts.GET_ITEM_REQUEST })
  return HTTP.get(`/${key}/client/${id}`)
    .then(response => dispatch({ type: consts.GET_ITEM_SUCCESS, response }))
    .catch(error => dispatch({ type: consts.GET_ITEM_FAIL, error }))
}

export const addItem = (data) => (dispatch) => {
  dispatch({ type: consts.ADD_ITEM_REQUEST })
  return HTTP.post(`/${key}`, data)
    .then(response => dispatch({ type: consts.ADD_ITEM_SUCCESS, response }))
    .catch(error => dispatch({ type: consts.ADD_ITEM_FAIL, error }))
}

export const removeItem = (id) => (dispatch) => {
  dispatch({ type: consts.REMOVE_ITEM_REQUEST })
  return HTTP.delete(`/${key}/${id}`)
    .then(response => dispatch({ type: consts.REMOVE_ITEM_SUCCESS, response }))
    .catch(error => dispatch({ type: consts.REMOVE_ITEM_FAIL, error }))
}

export const replaceItem = (id, data) => (dispatch) => {
  dispatch({ type: consts.REPLACE_ITEM_REQUEST })
  return HTTP.put(`/${key}/${id}`, data)
    .then(response => dispatch({ type: consts.REPLACE_ITEM_SUCCESS, response }))
    .catch(error => dispatch({ type: consts.REPLACE_ITEM_FAIL, error }))
}

export const setItemState = (item = {}) => (dispatch) => dispatch({ type: consts.SET_ITEM_STATE, item })


// reducers
export const actionHandlers = {
  [consts.GET_LIST_REQUEST]: (state) => state.withMutations((ctx) =>
    ctx.set('isFetching', true).set('error', null)),
  [consts.GET_LIST_SUCCESS]: (state, action) => state.withMutations((ctx) => {
    const data = obj.deepGet(action, ['response', 'data'], []);
    ctx.set('isFetching', false)
      .set('error', null)
      .set('list', data)
  }),
  [consts.GET_LIST_FAIL]: (state, action) => state.withMutations((ctx) =>
    ctx.set('isFetching', false).set('error', action.error)),

  [consts.GET_ITEM_REQUEST]: (state) => state.withMutations((ctx) =>
    ctx.set('isFetching', true).set('error', null)),
  [consts.GET_ITEM_SUCCESS]: (state, action) => state.withMutations((ctx) => {
    const data = obj.deepGet(action, ['response', 'data'], {})
    ctx.set('isFetching', false)
      .set('error', null)
      .set('item', new Item(data))
  }),
  [consts.GET_ITEM_FAIL]: (state, action) => state.withMutations((ctx) =>
    ctx.set('isFetching', false).set('error', action.error)),

  [consts.ADD_ITEM_REQUEST]: (state) => state.withMutations((ctx) =>
    ctx.set('isFetching', true).set('error', null)),
  [consts.ADD_ITEM_SUCCESS]: (state) => state.withMutations((ctx) => ctx.set('isFetching', false)),
  [consts.ADD_ITEM_FAIL]: (state, action) => state.withMutations((ctx) =>
    ctx.set('isFetching', false).set('error', action.error)),

  [consts.REMOVE_ITEM_REQUEST]: (state) => state.withMutations((ctx) =>
    ctx.set('isFetching', true).set('error', null)),
  [consts.REMOVE_ITEM_SUCCESS]: (state) => state.withMutations((ctx) => ctx.set('isFetching', false)),
  [consts.REMOVE_ITEM_FAIL]: (state, action) => state.withMutations((ctx) =>
    ctx.set('isFetching', false).set('error', action.error)),

  [consts.REPLACE_ITEM_REQUEST]: (state) => state.withMutations((ctx) =>
    ctx.set('isFetching', true).set('error', null)),
  [consts.REPLACE_ITEM_SUCCESS]: (state) => state.withMutations((ctx) => ctx.set('isFetching', false)),
  [consts.REPLACE_ITEM_FAIL]: (state, action) => state.withMutations((ctx) =>
    ctx.set('isFetching', false).set('error', action.error)),

  [consts.SET_ITEM_STATE]: (state, action) => state.withMutations((ctx) =>
    ctx.set('item', new Item(action.item))),
}

const initialState = new InitialState()
export const reducers = (state = initialState, action) => {
  const handler = actionHandlers[action.type]
  return handler ? handler(state, action) : state
}

export default reducers



// WEBPACK FOOTER //
// ./src/modules/notes.js